import { makeAutoObservable, runInAction } from "mobx";

export class DeploymentStore {
    logs: string[] = [];
    isRunning: boolean = false;
    target: string | null = null;

    root: any;

    constructor(root: any) {
        this.root = root;
        makeAutoObservable(this, { root: false } as any);
    }

    async fetchStatus() {
        // TODO(app-model): "get_deploy_status" no longer has a backend handler (old
        // agent.api.handlers.deploy was removed); wire to the app-model deployment surface
        // (see DeploymentEnvironment/DeploymentService.generated.ts) once available.
    }

    async run(target: string, env: "dev" | "test" | "prod") {
        runInAction(() => {
            this.isRunning = true;
            this.target = target;
            this.logs = [];
        });
        try {
            // TODO(app-model): "run_deploy" / "stop_deploy" no longer have backend handlers
            // (old agent.api.handlers.deploy was removed); wire to
            // DeploymentService.deploy/stop via the app-model RPC surface once this store
            // holds a container entity.
        } catch (e: any) {
            runInAction(() => { this.logs.push(`Error: ${e?.message ?? e}`); });
        } finally {
            runInAction(() => { this.isRunning = false; });
        }
    }

    addLog(content: string) {
        this.logs.push(content);
    }

    stop() {
        runInAction(() => { this.isRunning = false; });
        // TODO(app-model): "stop_deploy" no longer has a backend handler (old
        // agent.api.handlers.deploy was removed) -- wire to DeploymentService.stop via the
        // app-model RPC surface once this store holds a container entity.
    }

    clearLogs() {
        this.logs = [];
        this.target = null;
    }
}
